import { MovieStreamSubtitleMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SubtitlesConfig } from '../../Player';

export function transformSubtitles(
    subtitleMetas: MovieStreamSubtitleMetaFragment[]
): SubtitlesConfig {
    return subtitleMetas.map(
        (
            { title, language, url, visibleByDefault, languageName, studio, type, forAdult },
            index
        ) => ({
            title: title || '',
            language: language || '',
            url: url || '',
            visibleByDefault,
            index,
            languageName: languageName ?? undefined,
            studio: studio ?? undefined,
            type: type ?? undefined,
            forAdult: forAdult ?? false,
        })
    );
}
